import { useEffect, useState } from "react";
import { PageHeader } from "@/components/common/PageHeader";
import { DataTable } from "@/components/common/DataTable";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { fdate } from "@/lib/format";

export default function Auditoria() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => { api.get("/bitacora").then((r) => setRows(r.data)).catch(() => {}); }, []);

  const filtered = rows.filter((r) => !search || JSON.stringify(r).toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <PageHeader title="Auditoría y bitácoras" subtitle="Registro inmutable de eventos del sistema" />
      <div className="space-y-4 p-6 md:p-8">
        <div className="relative w-full sm:max-w-xs">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input data-testid="audit-search" placeholder="Buscar en bitácora..." value={search} onChange={(e) => setSearch(e.target.value)} className="pl-9" />
        </div>
        <p className="text-sm text-slate-500">{filtered.length} evento(s)</p>
        <DataTable testid="table-auditoria" rows={filtered}
          columns={[
            { key: "fecha", label: "Fecha", kind: "date" },
            { key: "hora", label: "Hora" },
            { key: "usuario", label: "Usuario" },
            { key: "modulo", label: "Módulo", kind: "badge" },
            { key: "accion", label: "Acción" },
            { key: "registro_afectado", label: "Registro" },
            { key: "descripcion", label: "Descripción" },
          ]} emptyLabel="Sin eventos registrados" />
      </div>
    </div>
  );
}
